import * as React from 'react';

export function P44OS(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      aria-label={props.label}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="navigation-icon-p44os"
      {...props}
    >
      <g clipPath="url(#clip0_8981_5569)">
        <path
          d="M1 2.5C1 1.39543 1.89543 0.5 3 0.5H11L17 6.5V18.5C17 19.6046 16.1046 20.5 15 20.5H3C1.89543 20.5 1 19.6046 1 18.5V2.5Z"
          fill="url(#paint0_linear_8981_5569)"
        />
        <path
          d="M11 0.5L17 6.5H12C11.4477 6.5 11 6.05228 11 5.5V0.5Z"
          fill="url(#paint1_linear_8981_5569)"
        />
        <g filter="url(#filter0_bi_8981_5569)">
          <path
            d="M15 9.50018C15 8.94789 15.4495 8.49373 15.9974 8.56259C17.3134 8.72795 18.5732 9.21876 19.6598 9.9974C21.0185 10.971 22.0381 12.3458 22.5754 13.9287C23.1127 15.5115 23.1407 17.2229 22.6555 18.8225C22.1703 20.422 21.1962 21.8294 19.8701 22.847C18.544 23.8646 16.9324 24.4412 15.2618 24.4959C13.5911 24.5506 11.9453 24.0806 10.5554 23.1519C9.1656 22.2233 8.10156 20.8826 7.51276 19.3182C7.04188 18.0671 6.89386 16.7232 7.07473 15.4092C7.15004 14.8621 7.70505 14.5455 8.23852 14.6884L14.3706 16.3315C14.6882 16.4166 15 16.1773 15 15.8486V9.50018Z"
            fill="white"
            fillOpacity="0.5"
          />
          <path
            d="M15.5 9.50018C15.5 9.20455 15.7279 9.03265 15.9351 9.05869C17.1688 9.21372 18.3499 9.67385 19.3686 10.4038C20.6424 11.3166 21.5983 12.6055 22.102 14.0894C22.6057 15.5733 22.632 17.1777 22.1771 18.6773C21.7222 20.1769 20.809 21.4963 19.5657 22.4503C18.3225 23.4043 16.8116 23.9449 15.2454 23.9962C13.6792 24.0474 12.1362 23.6068 10.8332 22.7362C9.53025 21.8656 8.53271 20.6087 7.98071 19.1421C7.53926 17.9692 7.40049 16.7092 7.57006 15.4774C7.59854 15.2705 7.82356 15.0949 8.10911 15.1714L14.2412 16.8145C14.8763 16.9847 15.5 16.5061 15.5 15.8486V9.50018Z"
            stroke="white"
            strokeOpacity="0.2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_bi_8981_5569"
          x="5.5"
          y="7.05566"
          width="19"
          height="18.9443"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.75" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_8981_5569"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_8981_5569"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_8981_5569"
          />
        </filter>
        <linearGradient
          id="paint0_linear_8981_5569"
          x1="9"
          y1="0.5"
          x2="9"
          y2="17.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF37D3" stopOpacity="0.01" />
          <stop offset="1" stopColor="#FF2FAC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8981_5569"
          x1="14"
          y1="0.5"
          x2="14"
          y2="6.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3788" stopOpacity="0.07" />
          <stop offset="1" stopColor="#FF2FAC" />
        </linearGradient>
        <clipPath id="clip0_8981_5569">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
